/**
 * Stub module to omit `prism-react-renderer` from the bundle.
 */
export const Prism = {};
export const themes = {
    dracula: { plain: {}, styles: [] },
    palenight: { plain: {}, styles: [] },
};
export const Highlight = () => null;
export default { Prism, themes, Highlight };

